import React from 'react';
import {SubtractInputField} from "../../../../../../../elements/subtractInputField/SubtractInputField";
import {SubtractionType, UpdateSubtractionRequest} from "../../../../../../../../api/generated";
import {useAppSelector} from "../../../../../../../../app/hooks";
import {RootState} from "../../../../../../../../app/store";
import styles from "./SubtractionLine.module.css";

interface Props {
    title: string;
    fieldName: string;
    errorMessage?: string;
    subtractionFieldSelector: (state: RootState) => UpdateSubtractionRequest;
    updateMultipliers: (fieldName: string, value: UpdateSubtractionRequest) => void;
    withBorderLine?: boolean;
    disabled?: boolean;
}

export const SubtractionLine: React.FC<Props> = ({
    title,
    fieldName,
    errorMessage,
    subtractionFieldSelector,
    updateMultipliers,
    withBorderLine = true,
    disabled
}) => {
    const subtractionField = useAppSelector(subtractionFieldSelector);

    const handleUpdateValue = (value: string) => {
        const numValue = Number(value) || 0;
        updateMultipliers(fieldName, {
            ...subtractionField,
            subtractionValue: numValue
        });
    };

    const handleUpdateType = (type: SubtractionType) => {
        updateMultipliers(fieldName, {
            ...subtractionField,
            subtractionType: type
        });
    };

    return (
        <div className={`${styles.wrapper} ${withBorderLine ? styles.withBorder : ''}`}>
            <div className={styles.title}>{title}</div>
            <SubtractInputField
                type="number"
                value={subtractionField.subtractionValue}
                setValue={handleUpdateValue}
                subtractionType={subtractionField.subtractionType as SubtractionType}
                onSubtractionChange={handleUpdateType}
                disabled={disabled}
                errorMessage={errorMessage}
            />
        </div>
    );
};

